import { Routes } from '@angular/router';

import { PaymentComponent } from './payment/payment.component';
import { SettlementComponent } from './settlement/settlement.component';

export const routes: Routes = [
  {
    // Default route = the station kiosk. This is what the column's Chromium opens fullscreen.
    path: '',
    component: PaymentComponent,
  },
  {
    // Settlement page for a parker's own phone (KAN-457). Reached only by scanning the exit-display
    // QR, which encodes this URL with the stay's id. Not station-specific: no terminal, no space,
    // no login — the parking-process id is the whole identity of the transaction.
    path: 'pay/:parkingProcessId',
    component: SettlementComponent,
  },
];
